<template>
  <div class="sku-search-form">
    <el-select v-model="selected_sku"
               :remote-method="fetchSkus"
               :loading="Sku.isLoading"
               :placeholder="$t('Please enter a keyword')"
               filterable
               remote
               reserve-keyword
               clearable
               value-key="id"
               style="width: 100%;">
      <el-option v-for="item in Sku.data"
                 :key="item.id"
                 :label="item.display_name"
                 :value="item" />
    </el-select>
    <SkuPreview v-if="selected_sku"
                :key="selected_sku.id"
                :project-id="projectId"
                :sku-id="selected_sku.id"
                :crop-data="cropData" />
    <el-button type="warning"
               :disabled="!bus.selected_crop"
               :loading="bus.validation_request"
               @click="apply">
      {{ $t('Apply') }}
    </el-button>
  </div>
</template>

<script>
import { createCrudState } from 'vuex-module-generator';
import { fetchSkus } from '@/shared/apis';
import SkuPreview from './SkuPreview';
import bus from '../sku-validation-scene/bus';
import componentBus, { EVENTS } from './componentBus';

export default {
  name: 'SkuSearchForm',
  components: {
    SkuPreview
  },
  props: {
    projectId: {
      type: [String, Number],
      required: true
    },
    skuGroupId: {
      type: [String, Number],
      required: true
    }
  },
  data() {
    return {
      bus,
      Sku: createCrudState().list,
      selected_sku: '',
      cropData: new Map()
    };
  },
  mounted() {
    componentBus.$on(EVENTS.IMAGE_SET_CHANGED, () => {
      this.Sku.data = [];
      this.selected_sku = '';
    });
  },
  methods: {
    apply() {
      this.$emit('apply', this.selected_sku);
    },
    async fetchSkus(search) {
      this.Sku.isLoading = true;
      try {
        const { data: { data } } = await fetchSkus(this.projectId, { per: 5000, search: { display_name: search, sku_group_id: this.skuGroupId } });
        this.Sku.data = data;
      } catch (error) {
        this.Sku.hasError = false;
      }
      this.Sku.isLoading = false;
    }
  }
};
</script>

<style lang="scss">
.sku-search-form {
  width: 100%;

  .sku-preview {
    box-sizing: border-box;
    min-height: 272px;
    padding: 10px;
    margin-top: 10px;
    border: 1px solid $terminatorChrome;
    border-radius: 4px;

    &__content {
      &-image {
        height: 200px;
      }
    }
  }

  .el-button {
    width: 100%;
    padding-top: 13px;
    padding-bottom: 13px;
    margin-top: 10px;
    text-transform: uppercase;
  }
}
</style>
